/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Leave_PageInputs */

const en_dialog_text_to_audio_leave_page = /** @type {(inputs: Dialog_Text_To_Audio_Leave_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave page`)
};

const es_dialog_text_to_audio_leave_page = /** @type {(inputs: Dialog_Text_To_Audio_Leave_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir de la página`)
};

/**
* | output |
* | --- |
* | "Leave page" |
*
* @param {Dialog_Text_To_Audio_Leave_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_leave_page = /** @type {((inputs?: Dialog_Text_To_Audio_Leave_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Leave_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_leave_page(inputs)
	return en_dialog_text_to_audio_leave_page(inputs)
});